'use strict';

import _ from 'lodash';

export default {
  loggedIn: state => {
    return !!state.accessToken && state.validTo.isAfter();
  },
  hasRole: (state, getters) => (role) => {
    return getters.loggedIn && state.user && state.user.roles.includes(role);
  },
  hasSomeRole: (state, getters) => (roles) => {
    return getters.loggedIn && state.user && _.intersection(state.user.roles, roles).length;
  }
}



// WEBPACK FOOTER //
// ./client/store/modules/auth/authGetters.js